// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._44xW5tefx{}._5IZjPopQx{flex-direction:column}.IlREmqz0x{align-items:center}\n", ""]);
// Exports
exports.locals = {
	"stretch": "_44xW5tefx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + "",
	"vertical": "_5IZjPopQx _44xW5tefx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + "",
	"centered": "IlREmqz0x"
};
module.exports = exports;
